import UserAppContext from "../../hook/UserAppContext"
import Title from '../../components/title/Title'
import BoxVideo from '../../components/video/BoxVideo'


const Video = ({isCurrent}) => {

      if(isCurrent !== 'video') return 

      const {user} = UserAppContext()
      const {videos} = user.user 

      return (
            <div className={isCurrent === 'video' ? "wrapper_page show" : "wrapper_page"}>
                  <div className="page_inner">
                        <Title text={`Video`}/>
                        <div className="wrapper_video">
                              <BoxVideo videos={videos} />
                        </div>
                  </div>
            </div>
      )
}

export default Video